export default __webpack_public_path__ + "static/media/forest.20d2fac6.svg";